const ITEMS = [
  "On-Premises AI Routing",
  "Model Context Protocol Gateway",
  "Enterprise Data Sovereignty",
  "Deterministic Latency Guard",
];

function Row() {
  return (
    <div className="flex items-center gap-8">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center gap-8">
          <span>{item}</span>
          <span>&mdash;</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      className="py-5 border-b border-linen bg-parchment-deep overflow-hidden"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <div className="mq-track font-mono text-xs uppercase tracking-widest text-umber gap-8">
        <Row />
        <Row />
      </div>
    </section>
  );
}
